import { AxiosResponse } from "axios";
import api from "./api.service";

export type InterviewAnalyticsFilters = {
	month?: string;
	week?: string;
	recruiter?: string;
	evaluator?: string;
	company?: string;
};

class InterviewService {
	static readonly listCompanies = (): Promise<AxiosResponse<any>> => {
		return api.get("analytics/companies");
	};

	static readonly listRecruiters = (): Promise<AxiosResponse<any>> => {
		return api.get("analytics/recruiters");
	};

	static readonly listMonths = (): Promise<AxiosResponse<any>> => {
		return api.get("analytics/months");
	};

	static readonly getDashboard = (
		filters: InterviewAnalyticsFilters
	): Promise<AxiosResponse<any>> => {
		return api.get("analytics/dashboard", { params: filters });
	};

	static readonly getInterviewAnalytics = (
		filters: InterviewAnalyticsFilters
	): Promise<AxiosResponse<any>> => {
		return api.get("analytics/interviews", { params: filters });
	};
}

export default InterviewService;
